import { on } from 'js/lib/events'
import { track } from '../component'

on('click', '.js-c-valentines-day-promo-banner__cta', function () {
  track('click', 'valentines day promo')
})
